import React, { useEffect, useState } from "react";
import Dashboard from "../../layouts/Dashboard";
import XTable from "../../components/XTable";
import InputField from "../../components/InputField";
import { Formik } from "formik";
import axios from "../../services/axios";
import * as yup from "yup";
import saveLog from "../../services/saveLog";
import { Card } from "antd";
import isConsultant from "../../services/isConsultant";

function ProcessCreate({ refetchProcesses }) {
  const initialValues = {
    name: "",
  };

  const validationSchema = yup.object({
    name: yup.string().required().min(2).label("Name"),
  });

  async function onSubmit(values, { resetForm }) {
    try {
      saveLog("PROCESS_CREATE", `Added a process ${values.name}`);
      await axios.post("/processes", values, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      });
      refetchProcesses();
      resetForm();
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <div>
    {!isConsultant() && <Card title="Create a process" className="border">
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <InputField id="name" label="Name" />
            <button className="btn btn-primary">Create</button>
          </form>
        )}
      </Formik>
    </Card>}
    </div>
  );
}

function SiteCreate({ refetchProcesses }) {
  const initialValues = {
    name: "",
  };

  const validationSchema = yup.object({
    name: yup.string().required().min(2).label("Name"),
  });

  async function onSubmit(values, { resetForm }) {
    saveLog("SITE_CREATE", `Added a site ${values.name}`);
    await axios.post("/sites", values, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user.token")}`,
      },
    });
    refetchProcesses();

    resetForm();
  }

  return (
    <div>
   {!isConsultant() &&  <Card title="Create a Site" className="border mt-4">
      <div>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <InputField id="name" label="Name" />
              <button className="btn btn-primary">Create</button>
            </form>
          )}
        </Formik>
      </div>
    </Card>}
    </div>
  );
}

function ProcessList({ processes, sites, refetchProcesses }) {
  async function onClickAddSiteToProcess(e) {
    saveLog("PROCESS_EDIT", `Added a site to process`);
    const process = e.target.getAttribute("process");
    const site = document.querySelector("#process_" + process).value;
    await axios.patch(
      "/processes/" + process,
      { site },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      }
    );
    refetchProcesses();
  }

  async function onClickDeleteSiteFromProcess(e) {
    saveLog("PROCESS_EDIT", `Deleted a site from process`);
    const process = e.target.getAttribute("process");
    const site = e.target.getAttribute("site");
    await axios.patch(
      "/processes/" + process + "/delete",
      { site },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      }
    );
    refetchProcesses();
  }

  return (
    <div>
    {!isConsultant() && <Card className="border">
      <XTable
        columns={["id", "name", "sites", "addSite"]}
        rows={processes.map((process, index) => {
          return {
            ...process,
            id: index + 1,
            sites: (
              <>
                {process.sites.length > 0 ? (
                  <div className="process-group">
                    {process.sites.map((site, index) => (
                      <span className="process" key={index}>
                        {site.name}{" "}
                        <div
                          className="process-delete"
                          process={process._id}
                          site={site._id}
                          onClick={onClickDeleteSiteFromProcess}
                        >
                          X
                        </div>
                      </span>
                    ))}
                  </div>
                ) : (
                  <div className="text-danger">No sites available</div>
                )}
              </>
            ),
            addSite: (
              <>
                {sites.filter((site) => {
                  return !process.sites
                    .map((_site) => _site.name)
                    .includes(site.name);
                }).length > 0 ? (
                  <div className="input-group">
                    <select
                      className="form-control"
                      id={"process_" + process._id}
                    >
                      {sites
                        .filter((site) => {
                          return !process.sites
                            .map((_site) => _site.name)
                            .includes(site.name);
                        })
                        .map((site, index) => (
                          <option key={index} value={site._id}>
                            {site.name}
                          </option>
                        ))}
                    </select>
                    <div className="input-group-append">
                      <button
                        className="btn btn-primary"
                        process={process._id}
                        onClick={onClickAddSiteToProcess}
                      >
                        Add
                      </button>
                    </div>
                  </div>
                ) : (
                  "No more sites to add"
                )}
              </>
            ),
            controls: (
              <div>
                <button
                  process={process._id}
                  className="btn btn-warning btn-sm mr-2"
                >
                  Edit
                </button>
                <button process={process._id} className="btn btn-danger btn-sm">
                  Delete
                </button>
              </div>
            ),
          };
        })}
      />
    </Card>}
    </div>
  );
}

export default function Process() {
  const [processes, setProcesses] = useState([]);
  const [sites, setSites] = useState([]);

  async function fetchProcess() {
    try {
      const { data } = await axios.get("/processes", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      });
      setProcesses(data.processes);
      setSites(data.sites);
    } catch (e) {
      console.error(e);
    }
  }

  useEffect(() => {
    fetchProcess();
  }, []);

  return (
    <div>
    {!isConsultant() && <Dashboard title="Process">
      <div className="row mb-4">
        <div className="col-lg-4">
          <ProcessCreate refetchProcesses={fetchProcess} />
          <SiteCreate refetchProcesses={fetchProcess} />
        </div>
        <div className="col-lg-8">
          <ProcessList
            processes={processes}
            sites={sites}
            refetchProcesses={fetchProcess}
          />
        </div>
      </div>
    </Dashboard>}
    </div>
  );
}
